// import { Box, Grid2, Skeleton } from '@mui/material'
// import React, {useEffect, useState} from 'react';
// import { Box, Grid2 } from '@mui/material'
// import React, {useState, useEffect} from 'react';
// import GiftHero from '../components/Hero/Hero';
// import GiftHeroImage from '../assets/GiftAsset/GiftHero.png';
// import CategoriesNavbar from '../components/CategoriesNavBar/CategoriesNavbar';
// import GiftCardComponent from '../components/CardComponent/CardComponent';
// import GiftSubHero from '../components/SubHero/SubHero';
// // import MoreGifts from '../components/MoreGifts'
// import ResponsiveNav from '../components/navigation/navigation';
// import { GiftCategories } from '../data/StaticDatas';
// import MoreGifts from '../components/MoreItems/MoreItems';
// import { Outlet } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';
// import { useGet } from '../hooks/useApi';


// const GiftShop = () => {
//     const [giftItems, setGiftItems] = useState([]); // Stores gift items
//     const [loading, setLoading] = useState(true); // Handles loading state
//     const [error, setError] = useState(null); // Handles errors
  
//     const fetchGiftItems = async () => {
//       const url = 'https://daradservice.azurewebsites.net/api/GiftItems/get-all-gift-Items';
//       console.log('called')
//       try {
//         console.log('before settttttt')
//         setLoading(true); // Set loading to true before fetching
//         console.log('after loadingggggggg')
//         const response = await fetch(url);
//         console.log('fetcheddddddddddddd')
  
//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//           console.log('responseeeeeeeeee')
//         }
//         console.log('dataeddddddddd')
//         const data = await response.json();
//         console.log(data)
//         console.log('Raw API Response:', data); // Log the raw response for debugging
  
//         // Check if "data" property exists and contains the gift items
//         if (data && data.data) {
//           setGiftItems(data.data); // Update state with gift items from "data"
//           console.log('setttttttttttttt')
//         } else {
//           setGiftItems([]); // If no data found, set empty array
//         }
//       } catch (error) {
//         setError(error.message); // Handle any errors
//       } finally {
//         setLoading(false); // Set loading to false after fetch
//       }
//     };
  
//     useEffect(() => {
//       fetchGiftItems(); // Fetch gift items when component mounts
//     }, []);
//   const [searchValue, setSearchValue] = useState('');
//   const location = useLocation()
//     // Handle search input change
//     const handleSearchChange = (event) => {
//       setSearchValue(event.target.value);
//     };
//     // Define breadcrumb items for Gift Shop
//     const breadcrumbItems = [
//       { label: 'Home', link: '/' },
//       { label: 'Gift Shop', link: '/product/giftshop' },
//     ];
//     const isChildRoute = location.pathname !== '/product/giftshop';

    
//   return (
//     <>
//     {!isChildRoute && (
//     <Box>
//       <ResponsiveNav breadcrumbItems={breadcrumbItems}  // Pass dynamic breadcrumbs
//         searchValue={searchValue} 
//         onSearchChange={handleSearchChange}
//         searchPlaceholder="Search for a digital course..."/>
//       <GiftHero heroImage={GiftHeroImage} heroTitle={'Gifts for Every Occasion'} heroDescription={'Find thoughtful gifts for every occasion. From personalized keepsakes to one-of-a-kind surprises, discover something special for everyone on your list.'}/>
//       <CategoriesNavbar title='All Gift Categories' categories={GiftCategories} to="/product/giftshop"/>
//       <Grid2 container spacing={6} justifyContent={'space-between'}>
//         {
//           [...Array(12)].map((item, index)=>{
//             return <Grid2 item xs={6} key={index} size={{ xs: 12, md: 4 }}>
//               <GiftCardComponent key={index} index={index} title={'Luxury Flower Bouquet'} description={'Beautifully arranged seasonal flowers'} amount={'₦10,000'} detailspath={`gift-details/${index}`}/>
//             </Grid2>
//           })
//         }
//       </Grid2>
//       <GiftSubHero/>
//       <MoreGifts title={`Gift ${'For Him'}`}/>
//     </Box>
//     )}
//     <Outlet/>
//     </>
//   )
// }

// export default GiftShop


import { Box, CircularProgress, Grid2, Typography } from '@mui/material'
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import GiftHero from '../components/Hero/Hero';
import GiftHeroImage from '../assets/GiftAsset/GiftHero.png';
import CategoriesNavbar from '../components/CategoriesNavBar/CategoriesNavbar';
import GiftCardComponent from '../components/CardComponent/CardComponent';
// import GiftSubHero from '../components/SubHero/SubHero';
// import MoreGifts from '../components/MoreGifts'
import ResponsiveNav from '../components/navigation/navigation';
// import { GiftCategories } from '../data/StaticDatas';
import MoreGifts from '../components/MoreItems/MoreItems';
// eslint-disable-next-line
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useGet } from '../hooks/useApi';
import { Toaster } from 'react-hot-toast';


// const GiftShop = () => {
//   const { data: gift, error: giftErr, isLoading: giftLoader } = useGet('/api/GiftItems/get-all-gift-Items');
//   const giftItems = gift?.data
//   console.log(giftItems)
//   const { data: catergories, error, isLoading } = useGet('/api/GiftItemCategories/get-all-categories');
//   const giftCategories = catergories?.data?.data
//   console.log('gift',giftCategories)
//   const [query, setQuery] = useState("");
  
//   // Filtered products based on the query
//   const [filteredProducts, setFilteredProducts] = useState(giftItems);
//   // if (isLoading) {
//   //   return filteredProducts
//   // }
//   const [searchValue, setSearchValue] = useState('');
//   const { data: searchItem, error: searchErr, isLoading: searchLoader } = useGet(`/api/GiftItems/search-item?searchTerm=${query}`);
//   const search = searchItem?.data
//   console.log('search',search)
//   const location = useLocation()

//     // Handle search input change

//     const handleSearchChange = (e) => {

//       // setSearchValue(event.target.value);
//       const searchQuery = e.target.value.toLowerCase();
//       setQuery(searchQuery);
      
//       // // Filter products by title or description
//       // const filtered = giftItems.filter((item) =>
//       //   item.name.toLowerCase().includes(searchQuery) ||
//       //   item.description.toLowerCase().includes(searchQuery)
//       // );
      
//       // setFilteredProducts(filtered);
//     };
//     const [loading, setLoading] = useState(false);
  
//   // Debounced filter function
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(true);
//       const filtered = giftItems?.filter((product) =>
//         product.name.toLowerCase().includes(query.toLowerCase()) ||
//         product.description.toLowerCase().includes(query.toLowerCase())
//       );
//       setFilteredProducts(filtered);
//       setLoading(false);
//     }, 500); // Delay after user stops typing (500ms)
    
//     return () => clearTimeout(timer);  // Cleanup the timer if the component unmounts or query changes
//   }, [query,giftItems]);  // Runs whenever the query changes
//     // Define breadcrumb items for Gift Shop
//     const breadcrumbItems = [
//       { label: 'Home', link: '/' },
//       { label: 'Gift Shop', link: '/product/giftshop' },
//     ];
//     const isChildRoute = location.pathname !== '/product/giftshop';
//  const {id} = useParams()

//     // const { data: itemDetails} = useGet(`/api/GiftItems/get-item-details/${id}`);
//     // const items = itemDetails?.data
//     // // const {longDesciption,name,size,} = item
//     // console.log(items);
    
    
//   return (
//     <>
//     {!isChildRoute && (
//     <Box>
//       <ResponsiveNav breadcrumbItems={breadcrumbItems}  // Pass dynamic breadcrumbs
//         searchValue={searchValue} 
//         onSearchChange={handleSearchChange}
//         searchPlaceholder="Search for a digital course..."/>
//       <GiftHero heroImage={GiftHeroImage} heroTitle={'Gifts for Every Occasion'} heroDescription={'Find thoughtful gifts for every occasion. From personalized keepsakes to one-of-a-kind surprises, discover something special for everyone on your list.'}/>
//       <CategoriesNavbar title='All Gift Categories' categories={giftCategories} to="/product/giftshop"/>
//       <Grid2 container spacing={6} justifyContent={'flex-start'}>
//       {loading && <CircularProgress sx={{ display: "block", margin: "0 auto" }} />}
//         {
//           filteredProducts?.length  === 0 ?   <Typography variant="h6" color="text.secondary" align="center">
//           No products found.
//         </Typography> :
//           filteredProducts?.map((item, index)=>{
//             return <Grid2 item xs={6} key={index} size={{ xs: 12, md: 4 }}>
//               <GiftCardComponent key={index} index={index} title={item.name} description={item.description} amount={item.price} detailspath={`gift-details/${item.id}`} imageUrl={item.imageUrl} itemId={item.id}/>
//             </Grid2>
//           })
//         }
//       </Grid2>
//       <GiftSubHero/>
//       <MoreGifts title={`Gift ${'For Him'}`} />
//     </Box>
//     )}
//     <Outlet/>
//     </>
//   )
// }
// const GiftShop = () => {
//   // State management
//   const [query, setQuery] = useState("");
//   const [searchValue, setSearchValue] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [displayedItems, setDisplayedItems] = useState([]);
  
//   // API calls using custom hook
//   const { 
//     data: giftData, 
//     error: giftErr, 
//     isLoading: giftLoader 
//   } = useGet('/api/GiftItems/get-all-gift-Items');
  
//   const { 
//     data: categoriesData, 
//     error: categoriesError, 
//     isLoading: categoriesLoading 
//   } = useGet('/api/GiftItemCategories/get-all-categories');
  
//   const { 
//     data: searchData, 
//     error: searchErr, 
//     isLoading: searchLoader 
//   } = useGet(`/api/GiftItems/search-item?searchTerm=${query}`);

//   // Derived values
//   const giftItems = giftData?.data || [];
//   const giftCategories = categoriesData?.data?.data || [];
//   const searchResults = searchData?.data || [];

//   // Debounced search handler
//   const debouncedSearch = useCallback(
//     debounce((searchQuery) => {
//       setQuery(searchQuery);
//     }, 300),
//     []
//   );

//   // Handle search input change
//   const handleSearchChange = (e) => {
//     const searchQuery = e.target.value.toLowerCase();
//     setSearchValue(searchQuery);
//     setLoading(true);
//     debouncedSearch(searchQuery);
//   };

//   // Update displayed items based on search results
//   useEffect(() => {
//     if (query === "") {
//       setDisplayedItems(giftItems);
//       setLoading(false);
//       return;
//     }

//     if (searchLoader) {
//       setLoading(true);
//       return;
//     }

//     if (searchData) {
//       setDisplayedItems(searchResults);
//       setLoading(false);
//     }
//   }, [query, searchData, searchLoader, giftItems, searchResults]);

//   // Location and routing
//   const location = useLocation();
//   const isChildRoute = location.pathname !== '/product/giftshop';
  
//   // Breadcrumb configuration
//   const breadcrumbItems = [
//     { label: 'Home', link: '/' },
//     { label: 'Gift Shop', link: '/product/giftshop' },
//   ];

//   if (giftLoader || categoriesLoading) {
//     return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
//   }

//   if (giftErr || categoriesError) {
//     return <Typography color="error">Error loading gift shop data</Typography>;
//   }

//   return (
//     <>
//       {!isChildRoute && (
//         <Box>
//           <ResponsiveNav 
//             breadcrumbItems={breadcrumbItems}
//             searchValue={searchValue}
//             onSearchChange={handleSearchChange}
//             searchPlaceholder="Search for a gift..."
//           />
          
//           <GiftHero 
//             heroImage={GiftHeroImage} 
//             heroTitle={'Gifts for Every Occasion'} 
//             heroDescription={'Find thoughtful gifts for every occasion. From personalized keepsakes to one-of-a-kind surprises, discover something special for everyone on your list.'}
//           />
          
//           <CategoriesNavbar 
//             title='All Gift Categories' 
//             categories={giftCategories} 
//             to="/product/giftshop"
//           />

//           <Grid2 container spacing={6} justifyContent={'flex-start'}>
//             {loading && (
//               <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress />
//               </Box>
//             )}
            
//             {!loading && displayedItems?.length === 0 && (
//               <Box sx={{ width: '100%', textAlign: 'center', p: 3 }}>
//                 <Typography variant="h6" color="text.secondary">
//                   No products found.
//                 </Typography>
//               </Box>
//             )}

//             {!loading && displayedItems?.map((item, index) => (
//               <Grid2 item xs={6} key={item.id} size={{ xs: 12, md: 4 }}>
//                 <GiftCardComponent 
//                   title={item.name}
//                   description={item.description}
//                   amount={item.price}
//                   detailspath={`gift-details/${item.id}`}
//                   imageUrl={item.imageUrl}
//                   itemId={item.id}
//                 />
//               </Grid2>
//             ))}
//           </Grid2>

//           <GiftSubHero />
//           <MoreGifts title={`Gift For Him`} />
//         </Box>
//       )}
//       <Outlet />
//     </>
//   );
// };
const GiftShop = () => {
// eslint-disable-next-line
  const { data, error, isLoading } = useGet('/api/GiftItems/get-all-gift-Items');
  const [category, setCategory] = useState('All Gift Categories');
  const [moreGifts, setMoreGifts] = useState([]);
  const [AddsData, setAddsData] = useState([]);
  // const navigate = useNavigate();
  // console.log(category)
 
  // State management
  // eslint-disable-next-line
  const [query, setQuery] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [displayedItems, setDisplayedItems] = useState([]);
  const [addsIndex, setAddsIndex] = useState(0);
    // const {pathname} = useLocation();
    console.log(addsIndex)
    const location = useLocation();
    // useEffect(() => {
    //   // Parse the query parameters from the URL
    //   const searchParams = new URLSearchParams(location.search);
    //   const authToken = searchParams.get("authToken");
    //   const token = localStorage.getItem('token');

  
    //   console.log("Extracted authToken:", authToken); // Debugging log
  
    //   // Ensure the authToken is non-empty and valid
    //   if (!token) {
    //     console.log("Invalid or missing authToken. Redirecting to external page...");
    //     window.location.href = "https://mydarads.com/dashboard/makeorder";
    //   }
    // }, [location.search]);
    // API calls using custom hook
    const { 
      data: giftData, 
      error: giftErr, 
      isLoading: giftLoader 
    } = useGet('/api/GiftItems/get-all-gift-Items');


  const { 
    data: categoriesData, 
    error: categoriesError, 
    isLoading: categoriesLoading 
  } = useGet('/api/GiftItemCategories/get-all-categories');
  // eslint-disable-next-line
  const categoriesDataList = categoriesData?.data?.data

  const { 
    data: searchData, 
    // eslint-disable-next-line
    error: searchErr, 
    isLoading: searchLoader 
  } = useGet(`/api/GiftItems/search-item?searchTerm=${query}`);

  // Memoized derived values
  const giftItems = useMemo(() => giftData?.data || [], [giftData]);
  const giftCategories = useMemo(() => categoriesData?.data?.data || [], [categoriesData]);
  const searchResults = useMemo(() => searchData?.data || [], [searchData]);
//  console.log(giftCategories);
// console.log(giftItems)
useEffect(() => {
  if (category === 'All Gift Categories') {
    setMoreGifts(giftItems);
    setDisplayedItems(giftItems);
  } else {
    const filteredGifts = giftItems?.filter(
      (item) => item?.categoryName.toLowerCase() === category?.description?.toLowerCase()
    );
    setMoreGifts(filteredGifts);
    setDisplayedItems(filteredGifts);
  }
}, [category, giftItems]);


useEffect(() => {
  const MoreGiftsData = giftItems?.filter((item) =>
    item?.categoryName.toLowerCase().includes(category?.description?.toLowerCase())
  );
  setMoreGifts(MoreGiftsData);
}, [category?.description, giftItems]);

useEffect(() => {
  const AddsMoreData = giftItems?.filter((item) =>
    item?.categoryName.toLowerCase().includes(addsIndex?.description?.toLowerCase())
  );
  console.log(AddsMoreData);
  setAddsData(AddsMoreData);
}, [addsIndex, giftItems]); 

// console.log(giftItems)
  // Debounced search handler
 

  // Handle search input change
  const handleSearchChange = useCallback((e) => {
    const searchQuery = e.target.value.toLowerCase();
    setSearchValue(searchQuery);
    setLoading(true);
  
    if (!searchQuery) {
      setDisplayedItems(giftItems);
      setLoading(false);
      return;
    }
  
    const filtered = giftItems.filter(item =>
      item.name?.toLowerCase().includes(searchQuery) ||
      item.description?.toLowerCase().includes(searchQuery)
    );
  
    setDisplayedItems(filtered);
    setLoading(false);
  }, [giftItems]);
  

  // Update displayed items based on search results
  useEffect(() => {
    if (query === "") {
      setDisplayedItems(giftItems);
      setLoading(false);
      return;
    }

    if (searchLoader) {
      setLoading(true);
      return;
    }
    if (categoriesLoading){
      setLoading(true)
      return
    }

    if (searchData) {
      setDisplayedItems(searchResults);
      setLoading(false);
    }
  }, [query, searchData, searchLoader, searchResults,giftItems, categoriesLoading]);

  // Location and routing
  const isChildRoute = location.pathname !== '/product/giftshop';
  
  // Breadcrumb configuration
  const breadcrumbItems = useMemo(() => [
    { label: 'Home', link: '/' },
    { label: 'Gift Shop', link: '/product/giftshop' },
  ], []);

  if (giftLoader || categoriesLoading) {
    return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
  }

  if (giftErr || categoriesError) {
    return <Typography color="error">    Our technical support team will fix it ASAP. Please try again later.</Typography>;
  }
  return (
    <>
      {!isChildRoute && (
        <Box sx={{ padding: { xs: 4, md: 8 } }}>
          <ResponsiveNav 
            breadcrumbItems={breadcrumbItems}
            searchValue={searchValue}
            onSearchChange={handleSearchChange}
            searchPlaceholder="Search for a gift..."
          />
          
          <GiftHero 
            heroImage={GiftHeroImage} 
            heroTitle={'Gifts for Every Occasion'} 
            heroDescription={'Find thoughtful gifts for every occasion. From personalized keepsakes to one-of-a-kind surprises, discover something special for everyone on your list.'}
          />
          
          <CategoriesNavbar 
            title='All Gift Categories' 
            categories={giftCategories}
            category={category} 
            giftItems={giftItems}
            setMoreGifts={setMoreGifts}
            setCategory={setCategory}
            addsIndex={addsIndex}
            setAddsIndex={setAddsIndex}
            to="/product/giftshop"
          />

          <Grid2 container spacing={6} justifyContent={'flex-start'}>
            {loading && (
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
              </Box>
            )}
            
           
            {!loading && moreGifts?.map((item, index) => (
  <Grid2 item xs={6} key={item.id} size={{ xs: 12, md: 4 }}>
    <GiftCardComponent 
      title={item.name}
      description={item.description}
      amount={item.price}
      detailspath={`gift-details/${item.id}`}
      imageUrl={item.imageUrl}
      itemId={item.id}
    />
  </Grid2>
))}

{!loading && displayedItems?.map((item, index) => (
  <Grid2 item xs={6} key={item.id} size={{ xs: 12, md: 4 }}>
    <GiftCardComponent 
      title={item.name}
      description={item.description}
      amount={item.price}
      detailspath={`gift-details/${item.id}`}
      imageUrl={item.imageUrl}
      itemId={item.id}
    />
  </Grid2>
))}

          </Grid2>

          {/* <GiftSubHero /> */}
          <MoreGifts title={addsIndex.name} moreItems={AddsData}>
          </MoreGifts>
          <Toaster />
        </Box>
      )}
      <Outlet />
    </>
  );
};

export default GiftShop;